module.exports = __webpack_public_path__ + "img/album15_16.c09871f1.jpg";